<template>
	<div
		class="input-field"
		:class="{
			readonly,
			highlighted: hasError
		}"
	>
		<input
			type="text"
			:required="required"
			autocomplete="off"
			:value="currentValue"
			:maxlength="maxLength"
			:placeholder="placeholder"
			:readonly="readonly"
			@input.prevent="handleInput"
			@change.prevent="changeInput"
			@focus="handleFocus"
			@keyup.enter="onEnter"
		/>
		<span v-if="value && showClear" class="input-clear" @click="clearValue">
			clear
		</span>
		<span class="input-counter" v-if="showCounter">
			{{ currentValue ? currentValue.length : 0 }}/{{ maxLength }}
		</span>
	</div>
</template>

<script>
export default {
	name: 'Input',

	props: {
		value: {
			type: String,
			default: ''
		},

		placeholder: {
			type: String
		},

		maxLength: {
			type: Number,
			default: 30
		},

		autoSelectText: {
			type: Boolean,
			default: false
		},

		readonly: {
			type: Boolean,
			default: false
		},

		showCounter: {
			type: Boolean,
			default: true
		},

		showClear: {
			type: Boolean,
			default: true
		},

		hasError: {
			type: Boolean,
			default: false
		},

		required: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			currentValue: ''
		}
	},

	created() {
		this.currentValue = this.value || ''
	},

	watch: {
		value(val) {
			this.currentValue = val || ''
		}
	},

	methods: {
		handleFocus(e) {
			if (this.autoSelectText) {
				this.selectInputText(e)
			}
		},

		handleInput(e) {
			this.currentValue = e.target.value.slice(0, this.maxLength)

			this.$emit('input', this.currentValue)
		},

		changeInput(e) {
			this.currentValue = e.target.value.slice(0, this.maxLength)

			this.$emit('input', this.currentValue)
		},

		clearValue() {
			this.currentValue = ''
			this.$emit('input', this.currentValue)
		},

		selectInputText(e) {
			e.target.select()
		},

		onEnter() {
			this.$emit('enter')
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.input-field {
	&.highlighted {
		border-color: $alertRed;

		&:after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			bottom: -1px;
			height: 1px;
			overflow: hidden;
			transform: scale(0.1);
			animation: input-pulse-red 1.1s 3;
		}
	}

	&.readonly {
		pointer-events: none;
	}

	input {
		padding-right: 24px;
	}
}
</style>
